import { useQuery } from "hooks/useQuery";
import { getCommunityStrategiesDetailsV2 } from "features/Strategy/service";

export const useCommunityStrategyDetails = (strategyId) => {
  const { isLoading, data } = useQuery({
    key: "communityStrategyDetails",
    queryKey: ["communityStrategyDetails", strategyId],
    queryFn: async () => {
      const response = await getCommunityStrategiesDetailsV2(strategyId);
      return response?.data;
    },
    enabled: Boolean(strategyId),
  });

  return {
    isLoading,
    strategyDetails: data,
    profitLossData: data?.profit_loss,
  };
};
